import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';
import { Button } from './ui/button';

const Navbar = ({ onBookCall }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="bg-white shadow-sm sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <Link to="/" className="flex items-center">
            <img 
              src="https://customer-assets.emergentagent.com/job_lokal-landing/artifacts/q6bvd26u_The%20Lokal%20Winery%20%281%29.png" 
              alt="The Lokal Winery" 
              className="h-16 md:h-20"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <Link to="/" className="text-gray-700 hover:text-red-900 transition-colors font-medium">
              Home
            </Link>
            <Link to="/wines" className="text-gray-700 hover:text-red-900 transition-colors font-medium">
              Our Wines
            </Link>
            <Link to="/process" className="text-gray-700 hover:text-red-900 transition-colors font-medium">
              The Process
            </Link>
            <Link
              to="/order"
              data-track="order:nav_order_now"
              data-testid="nav-order-now-desktop"
              className="text-[#FDB913] hover:text-[#E5A50A] transition-colors font-bold"
            >
              Order Now!
            </Link>
            <Link to="/weddings" className="text-gray-700 hover:text-red-900 transition-colors font-medium">
              Weddings
            </Link>
            <Link
              to="/wine-of-the-year"
              data-track="contest:nav_woty"
              data-testid="nav-woty-desktop"
              className="text-[#722F37] hover:text-[#5A252B] transition-colors font-bold"
            >
              🎨 Wine of the Year
            </Link>
            <Link
              to="/holiday-gifting"
              data-track="gifting:nav_holiday"
              data-testid="nav-holiday-desktop"
              className="text-[#722F37] hover:text-[#5A252B] transition-colors font-bold"
            >
              🎁 Holiday Gifts
            </Link>
            <a
              href="https://klone.thelokal.ca"
              data-track="klone:nav_klone"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="nav-klone-cellar-desktop"
              className="text-[#F5A623] hover:text-[#D4891A] transition-colors font-bold"
            >
              🍷 Klone Cellar
            </a>
            <Button 
              onClick={onBookCall}
              data-track="book_call:nav_book_call"
              className="bg-[#FDB913] hover:bg-[#E5A50A] text-gray-900 font-semibold"
            >
              <Phone className="w-4 h-4 mr-2" />
              Book a Call
            </Button>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden text-gray-700 hover:text-red-900"
          >
            {isOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <div className="md:hidden pb-4 space-y-3">
            <Link
              to="/"
              className="block text-gray-700 hover:text-red-900 transition-colors font-medium py-2"
              onClick={() => setIsOpen(false)}
            >
              Home
            </Link>
            <Link
              to="/wines"
              className="block text-gray-700 hover:text-red-900 transition-colors font-medium py-2"
              onClick={() => setIsOpen(false)}
            >
              Our Wines
            </Link>
            <Link
              to="/process"
              className="block text-gray-700 hover:text-red-900 transition-colors font-medium py-2"
              onClick={() => setIsOpen(false)}
            >
              The Process
            </Link>
            <Link
              to="/order"
              data-testid="nav-order-now-mobile"
              className="block text-[#FDB913] hover:text-[#E5A50A] transition-colors font-bold py-2"
              onClick={() => setIsOpen(false)}
            >
              Order Now!
            </Link>
            <Link
              to="/weddings"
              className="block text-gray-700 hover:text-red-900 transition-colors font-medium py-2"
              onClick={() => setIsOpen(false)}
            >
              Weddings
            </Link>
            <Link
              to="/wine-of-the-year"
              data-testid="nav-woty-mobile"
              className="block text-[#722F37] hover:text-[#5A252B] transition-colors font-bold py-2"
              onClick={() => setIsOpen(false)}
            >
              🎨 Wine of the Year
            </Link>
            <Link
              to="/holiday-gifting"
              data-testid="nav-holiday-mobile"
              className="block text-[#722F37] hover:text-[#5A252B] transition-colors font-bold py-2"
              onClick={() => setIsOpen(false)}
            >
              🎁 Holiday Gifts
            </Link>
            <a
              href="https://klone.thelokal.ca"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="nav-klone-cellar-mobile"
              className="block text-[#F5A623] hover:text-[#D4891A] transition-colors font-bold py-2"
              onClick={() => setIsOpen(false)}
            >
              🍷 Klone Cellar
            </a>
            <Button 
              data-track="book_call:nav_mobile_book_call"
              onClick={() => {
                onBookCall();
                setIsOpen(false);
              }}
              className="w-full bg-[#FDB913] hover:bg-[#E5A50A] text-gray-900 font-semibold"
            >
              <Phone className="w-4 h-4 mr-2" />
              Book a Call
            </Button>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;